import { FormLayout } from '@kcftech/design-system';
import { WizardContent } from 'components/wizard/WizardContent';
import { AnalyticsIndicatorsInput } from 'pages/Models/AnalyticsModelTab/AnalyticsIndicatorsInput';
import {
    FeatureIndicatorsSection,
    SmartIndicatorsSection,
} from 'pages/Models/AnalyticsModelTab/shared';
import { useForm } from 'react-hook-form';

export type ModelIndicatorFormData = Readonly<{
    key: string;
    name: string;
    unit: string;
}>;

export type CreateModelStep3FormData = Readonly<{
    featureIndicators: ModelIndicatorFormData[];
    smartIndicators: ModelIndicatorFormData[];
}>;

export type CreateModelStep3Props = Readonly<{
    data: CreateModelStep3FormData;
    onCancel: () => void;
    onBack: (newData: CreateModelStep3FormData) => void;
    onNext: (newData: CreateModelStep3FormData) => void;
}>;

export function CreateModelStep3({
    data,
    onCancel,
    onBack,
    onNext,
}: CreateModelStep3Props) {
    const form = useForm<CreateModelStep3FormData>({
        mode: 'onSubmit',
        reValidateMode: 'onChange',
        defaultValues: data,
        shouldUnregister: false,
    });

    const {
        formState: { isValidating, isSubmitting, isSubmitted, isValid },
        getValues,
        handleSubmit,
    } = form;

    return (
        <WizardContent
            canCancel={!isSubmitting}
            canProceed={!isValidating && !isSubmitting && !(isSubmitted && !isValid)}
            onCancel={onCancel}
            onBack={() => onBack(getValues())}
            onNext={handleSubmit(onNext)}
        >
            <FormLayout>
                <FeatureIndicatorsSection />
                <AnalyticsIndicatorsInput form={form} type="feature" />

                <SmartIndicatorsSection />
                <AnalyticsIndicatorsInput form={form} type="smart" />
            </FormLayout>
        </WizardContent>
    );
}
